import React, { Component } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { PageHeader } from '../components/PageHeader';
import { SEO } from '../components/SEO';
import { Calendar, User, Clock, Share2, Facebook, Twitter, Linkedin } from 'lucide-react';
import { Link } from 'react-router-dom';
export function BlogPage() {
  // Featured article from The Glitters Online
  const featuredArticle = {
    title: 'Sanwo-Olu Congratulates Senator Fatimat Raji-Rasaki At 70',
    excerpt: 'Lagos State Governor Babajide Sanwo-Olu celebrates Senator Fatimat Raji-Rasaki on her 70th birthday, commending her dedication to public service and community development.',
    author: 'Kazeem Tunde',
    date: '2026/01/12',
    readTime: '3 Min Read',
    category: 'News',
    image: 'https://cdn.magicpatterns.com/uploads/ebg69ikW9uruxw2VgRQH1C/575d5148-67b3-4125-b7ee-4dd154991d71.jpg',
    externalLink: 'https://theglittersonline.com.ng/sanwo-olu-223/',
    content: `
      <p>Lagos State Governor, Babajide Sanwo-Olu, has extended warm congratulations to Senator Fatimat Raji-Rasaki on the occasion of her 70th birthday, celebrating her remarkable contributions to public service and community development in Nigeria.</p>
      
      <p>In a statement released by the Governor's office, Sanwo-Olu praised Senator Raji-Rasaki's unwavering commitment to improving the lives of Nigerians through her legislative work and humanitarian initiatives. He highlighted her dedication to education, healthcare, and social empowerment programs that have touched countless lives across the nation.</p>
      
      <p>"Senator Fatimat Raji-Rasaki represents the very best of public service in Nigeria," Governor Sanwo-Olu stated. "Her seven decades of life have been marked by selfless service, compassion, and an unwavering commitment to the betterment of our society. Through the Senator Fatimat Raji Rasaki Foundation, she continues to transform lives and build futures for vulnerable communities."</p>
      
      <p>The Governor commended her work in agriculture, healthcare access, humanitarian services, and social empowerment, noting that her foundation's impact spans multiple states across Nigeria. He particularly praised her non-political, community-centered approach to development, which has earned her respect across party lines.</p>
      
      <p>"As she marks this milestone, we celebrate not just her years, but the countless lives she has touched, the communities she has strengthened, and the legacy of service she continues to build," the statement continued.</p>
      
      <p>Senator Raji-Rasaki, who served in the Nigerian Senate, has dedicated her post-legislative career to structured humanitarian service through her foundation, focusing on sustainable development and grassroots impact. Her work encompasses six key areas: agriculture and food security, healthcare access, humanitarian services, clean water and sanitation, social empowerment, and nation building.</p>
      
      <p>Governor Sanwo-Olu wished Senator Raji-Rasaki continued good health, wisdom, and strength to carry on her impactful work, expressing confidence that her legacy of service will inspire future generations of Nigerian leaders.</p>
    `
  };
  const handleShare = (platform: string) => {
    const url = window.location.href;
    const text = featuredArticle.title;
    const shareUrls: {
      [key: string]: string;
    } = {
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
      twitter: `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`,
      linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`
    };
    if (shareUrls[platform]) {
      window.open(shareUrls[platform], '_blank', 'width=600,height=400');
    }
  };
  return <div className="font-sans bg-warm-ivory min-h-screen w-full" data-id="element-471">
      <SEO title="Blog - SFRR Foundation News & Updates" description="Stay updated with the latest news, stories, and insights from the Senator Fatimat Raji Rasaki Foundation. Read about our impact, events, and community initiatives." keywords="SFRR Foundation blog, nonprofit news Nigeria, community development updates, Senator Fatimat Raji Rasaki news" data-id="element-472" />

      <Header data-id="element-473" />
      <main className="w-full font-sans" data-id="element-474">
        <PageHeader title="News & Updates" subtitle="Stay informed about our work, impact stories, and community initiatives" badgeText="BLOG" backgroundImage="https://cdn.magicpatterns.com/uploads/2TJ6UkgbUQGJTAPF9Zz8N9/SFRR_Foundation_(4).jpg" data-id="element-475" />

        {/* Featured Article */}
        <section className="py-20 bg-white" data-id="element-476">
          <div className="container mx-auto px-4" data-id="element-477">
            <div className="max-w-4xl mx-auto" data-id="element-478">
              {/* Category Badge */}
              <span className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary text-sm font-semibold mb-6" data-id="element-479">
                {featuredArticle.category}
              </span>

              {/* Article Title */}
              <h1 className="text-4xl md:text-5xl font-serif font-bold text-charcoal mb-6 leading-tight" data-id="element-480">
                {featuredArticle.title}
              </h1>

              {/* Meta Information */}
              <div className="flex flex-wrap items-center gap-6 mb-8 text-neutral-600" data-id="element-481">
                <div className="flex items-center gap-2" data-id="element-482">
                  <User className="w-4 h-4" data-id="element-483" />
                  <span className="text-sm" data-id="element-484">{featuredArticle.author}</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-485">
                  <Calendar className="w-4 h-4" data-id="element-486" />
                  <span className="text-sm" data-id="element-487">{featuredArticle.date}</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-488">
                  <Clock className="w-4 h-4" data-id="element-489" />
                  <span className="text-sm" data-id="element-490">{featuredArticle.readTime}</span>
                </div>
              </div>

              {/* Featured Image */}
              <div className="relative rounded-3xl overflow-hidden shadow-xl mb-12 aspect-video" data-id="element-491">
                <img src={featuredArticle.image} alt={featuredArticle.title} className="w-full h-full object-cover" loading="eager" data-id="element-492" />
              </div>

              {/* Share Buttons */}
              <div className="flex items-center gap-4 mb-12 pb-8 border-b border-neutral-200" data-id="element-493">
                <span className="text-sm font-medium text-neutral-600 flex items-center gap-2" data-id="element-494">
                  <Share2 className="w-4 h-4" data-id="element-495" />
                  Share:
                </span>
                <button onClick={() => handleShare('facebook')} className="w-10 h-10 rounded-full bg-neutral-100 flex items-center justify-center text-neutral-600 hover:bg-blue-600 hover:text-white transition-all duration-300" aria-label="Share on Facebook" data-id="element-496">
                  <Facebook className="w-4 h-4" data-id="element-497" />
                </button>
                <button onClick={() => handleShare('twitter')} className="w-10 h-10 rounded-full bg-neutral-100 flex items-center justify-center text-neutral-600 hover:bg-sky-500 hover:text-white transition-all duration-300" aria-label="Share on Twitter" data-id="element-498">
                  <Twitter className="w-4 h-4" data-id="element-499" />
                </button>
                <button onClick={() => handleShare('linkedin')} className="w-10 h-10 rounded-full bg-neutral-100 flex items-center justify-center text-neutral-600 hover:bg-blue-700 hover:text-white transition-all duration-300" aria-label="Share on LinkedIn" data-id="element-500">
                  <Linkedin className="w-4 h-4" data-id="element-501" />
                </button>
              </div>

              {/* Article Content */}
              <div className="prose prose-lg max-w-none mb-12" dangerouslySetInnerHTML={{
              __html: featuredArticle.content
            }} style={{
              fontSize: '1.125rem',
              lineHeight: '1.8',
              color: '#374151'
            }} data-id="element-502" />

              {/* Read Full Article CTA */}
              <div className="bg-gradient-to-br from-primary/5 to-secondary/5 rounded-2xl p-8 text-center mb-12" data-id="element-503">
                <h3 className="text-2xl font-serif font-bold text-charcoal mb-4" data-id="element-504">
                  Read the Full Article
                </h3>
                <p className="text-neutral-600 mb-6" data-id="element-505">
                  This article was originally published on The Glitters Online
                </p>
                <a href={featuredArticle.externalLink} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-8 py-4 bg-primary text-white rounded-full font-semibold hover:bg-primary-600 transition-all duration-300 hover:-translate-y-0.5 shadow-md hover:shadow-lg" data-id="element-506">
                  Visit The Glitters Online
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-507">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" data-id="element-508" />
                  </svg>
                </a>
              </div>

              {/* About Senator Section */}
              <div className="bg-warm-ivory rounded-2xl p-8 border border-neutral-100" data-id="element-509">
                <h3 className="text-xl font-bold text-charcoal mb-4" data-id="element-510">
                  About Senator Fatimat Raji-Rasaki
                </h3>
                <p className="text-neutral-600 leading-relaxed mb-6" data-id="element-511">
                  Senator Fatimat Raji-Rasaki is a distinguished Nigerian public
                  servant and humanitarian. As the founder of the Senator
                  Fatimat Raji Rasaki Foundation (SFRR), she has dedicated her
                  life to improving the welfare of vulnerable communities across
                  Nigeria through sustainable development programs in
                  agriculture, healthcare, education, and humanitarian services.
                </p>
                <Link to="/about" className="inline-flex items-center gap-2 text-primary font-semibold hover:gap-3 transition-all duration-300" data-id="element-512">
                  Learn More About Our Foundation
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-513">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" data-id="element-514" />
                  </svg>
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Related Content */}
        <section className="py-16 bg-gradient-to-b from-warm-ivory to-white" data-id="element-515">
          <div className="container mx-auto px-4" data-id="element-516">
            <div className="max-w-4xl mx-auto" data-id="element-517">
              <h2 className="text-3xl font-serif font-bold text-charcoal mb-8 text-center" data-id="element-518">
                Explore More
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-519">
                {[{
                title: 'Our Impact',
                description: 'See the measurable difference we make',
                link: '/impact',
                icon: '📊'
              }, {
                title: 'Success Stories',
                description: 'Read inspiring transformation stories',
                link: '/stories',
                icon: '💫'
              }, {
                title: 'Our Programs',
                description: 'Discover our six focus areas',
                link: '/programs',
                icon: '🎯'
              }].map((item, index) => <Link key={index} to={item.link} className="bg-white rounded-xl p-6 shadow-soft hover:shadow-hover transition-all duration-300 hover:-translate-y-1 group" data-id="element-520">
                    <div className="text-4xl mb-4" data-id="element-521">{item.icon}</div>
                    <h3 className="text-lg font-bold text-charcoal mb-2 group-hover:text-primary transition-colors" data-id="element-522">
                      {item.title}
                    </h3>
                    <p className="text-sm text-neutral-600" data-id="element-523">
                      {item.description}
                    </p>
                  </Link>)}
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-524" />
    </div>;
}